import { render } from "./MarketplaceIcon.vue?vue&type=template&id=0dbd3c16"
import script from "./MarketplaceIcon.vue?vue&type=script&lang=js"
export * from "./MarketplaceIcon.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__